import { TrackedObject } from "./TrackedObject";
import { TrackedCollection } from "./TrackedCollection";
import { ContainerChildren } from "./ContainerChildren";

/**
 * A {@link TrackedObject} (EventTracker model) that aggregates the validity of
 * its children: other tracked objects, collections, and their object items.
 * For a DirtyTracker, use `DirtyTrackedContainer`.
 */
export abstract class TrackedContainer extends TrackedObject {
  private readonly _kids = new ContainerChildren();

  protected trackChild(child: TrackedObject | TrackedCollection<any>): void {
    this._kids.track(child);
  }

  protected untrackChild(child: TrackedObject | TrackedCollection<any>): void {
    this._kids.untrack(child);
  }

  override get trakrIsValid(): boolean {
    return super.trakrIsValid && this._kids.allValid;
  }

  override set trakrIsValid(value: boolean) {
    this._setIsValid(value);
  }

  override destroy(): void {
    this._kids.dispose();
    super.destroy();
  }
}
